import React from 'react';
import Return from './Return';
const ReturnS = ({ color, ...props }) => (React.createElement(Return, Object.assign({ color: color, size: 24 }, props)));
ReturnS.displayName = 'ReturnS'; // Fix for tsc
export default ReturnS;
//# sourceMappingURL=ReturnS.js.map